(function () {
  'use strict';
  const Clients = window.AAHeadquartersClients;
  const proto = Clients?.prototype;
  if (!proto || proto.__aaTaskAnchorRepair) return;
  const api = window.AASupabaseClient;
  let lastSaveError = '';

  if (api?.getClient && api.createSharedTaskAnchor && api.updateSharedTaskAnchor) {
    const oldSharedUpdate = api.updateSharedTaskAnchor.bind(api);
    function normalize(payload) {
      const kind = payload.scheduleKind || 'day_of_month';
      const periodic = ['yearly','yearly_flexible','quarterly','quarterly_flexible'].includes(kind);
      const owner = payload.useClientOwner !== false;
      const counted = payload.countsTowardPackage !== false;
      return {
        task_name: String(payload.taskName || '').trim(),
        task_type: String(payload.taskType || '').trim(),
        schedule_kind: kind,
        day_of_month: ['day_of_month','yearly','quarterly'].includes(kind) ? Number(payload.dayOfMonth || 1) : null,
        month_of_year: periodic ? Number(payload.monthOfYear || 1) : null,
        week_of_month: kind === 'nth_weekday' ? (payload.weekOfMonth || 'first') : null,
        weekday: ['nth_weekday','weekly'].includes(kind) ? (payload.weekday || 'Monday') : null,
        use_client_owner: owner,
        assignee_team_member_id: owner ? null : (payload.assigneeTeamMemberId || null),
        counts_toward_package: counted,
        package_service_catalog_id: counted ? (payload.packageServiceCatalogId || null) : null,
        notes: String(payload.notes || ''),
        is_active: payload.isActive !== false
      };
    }
    async function persist(id, payload, ids) {
      const selected = Array.isArray(ids) ? [...new Set(ids.map(String).filter(Boolean))] : [];
      if (!selected.length) throw new Error('Choose at least one client.');
      try {
        const db = api.getClient();
        if (!db) throw new Error('Headquarters connection unavailable.');
        const {data,error} = await db.rpc('aa_save_shared_task_anchor', {
          p_id: id || null, p_anchor: normalize(payload), p_client_ids: selected
        });
        if (error) throw error;
        if (!data?.id) throw new Error('No confirmation was returned for the saved anchor.');
        return data;
      } catch (error) {
        lastSaveError = error?.message || 'The database rejected the change.';
        throw error;
      }
    }
    api.createSharedTaskAnchor = payload => persist(null, payload, payload.clientIds);
    api.updateSharedTaskAnchor = ({id, updates = {}, clientIds} = {}) =>
      Array.isArray(clientIds) ? persist(id, updates, clientIds) :
        oldSharedUpdate({id, updates});
  }

  for (const name of ['createClientTaskAnchor','updateClientTaskAnchor']) {
    if (typeof api?.[name] !== 'function') continue;
    const original = api[name].bind(api);
    api[name] = async (...args) => {
      try { return await original(...args); }
      catch (error) {
        lastSaveError = error?.message || 'The database rejected the change.';
        throw error;
      }
    };
  }

  proto.loadActiveClientTaskAnchors = async function () {
    const clientId = this.getActiveClient?.()?.id || '';
    const token = (this.__aaAnchorLoadToken || 0) + 1;
    this.__aaAnchorLoadToken = token;
    if (clientId !== this.__aaAnchorLoadedClient) {
      this.__aaAnchorLoadedClient = clientId;
      this.clientTaskAnchors = [];
      this.sharedTaskAnchors = [];
      this.clientProductionSettings = null;
      this.taskTypes = [];
    }
    if (!clientId) return;
    this.clientTaskAnchorsLoading = true;
    this.sharedTaskAnchorsLoading = true;
    const actions = [
      ['Client Task Anchors', () => api.getClientTaskAnchors({clientId, includeInactive:true})],
      ['Shared Task Anchors', () => api.getSharedTaskAnchors({includeInactive:true})],
      ['Production Rules', () => api.getClientProductionSettings({clientId})],
      ['Task Types', () => api.getTaskTypes()]
    ];
    const results = await Promise.allSettled(actions.map(([,fn])=> Promise.resolve().then(fn)));
    if (token !== this.__aaAnchorLoadToken || clientId !== this.getActiveClient?.()?.id) return;
    const issues = [];
    results.forEach((r,i) => {
      if (r.status !== 'fulfilled') {
        issues.push(actions[i][0]);
        console.warn('Unable to load ' + actions[i][0],r.reason);
        return;
      }
      if (i === 0 && Array.isArray(r.value)) this.clientTaskAnchors = r.value;
      if (i === 1 && Array.isArray(r.value)) this.sharedTaskAnchors = r.value;
      if (i === 2) this.clientProductionSettings = r.value || null;
      if (i === 3 && Array.isArray(r.value)) this.taskTypes = r.value;
    });
    this.__aaAnchorLoadIssues = issues;
    this.clientTaskAnchorsLoading = false;
    this.sharedTaskAnchorsLoading = false;
  };

  const originalPanel = proto.renderTaskAnchorsPanel;
  if (typeof originalPanel === 'function') {
    proto.renderTaskAnchorsPanel = function(client) {
      const saved = this.sharedTaskAnchors;
      const belongs = x => (x.clientIds || []).some(id=>String(id)===String(client.id));
      this.sharedTaskAnchors = [...(saved || [])].sort((a,b)=>Number(belongs(b))-Number(belongs(a)));
      let html;
      try { html = originalPanel.call(this,client); }
      finally { this.sharedTaskAnchors = saved; }
      const marker = '<section class="aa-client-task-anchor-section">';
      const first = html.indexOf(marker);
      const second = html.indexOf(marker,first+marker.length);
      const close = '</section>';
      const firstEnd = html.lastIndexOf(close,second)+close.length;
      const secondEnd = html.indexOf(close,second)+close.length;
      if (first>=0 && second>first && firstEnd>first && secondEnd>second) {
        html = html.slice(0,first)+html.slice(second,secondEnd)+
          html.slice(firstEnd,second)+html.slice(first,firstEnd)+html.slice(secondEnd);
      }
      if (this.__aaAnchorLoadIssues?.length) {
        const label = this.__aaAnchorLoadIssues.map(x=>this.escapeHtml(x)).join(', ');
        html = html.replace('<div class="aa-client-task-anchor-sections">',
          '<p role="alert">Some Task Anchor data could not load ('+label+'). Saved records have not been deleted. Reopen Task Anchors to retry.</p>'+
          '<div class="aa-client-task-anchor-sections">');
      }
      return html;
    };
  }

  const newTypeHtml = [
    '<div class="aa-anchor-type-create" style="margin-top:8px">',
    '<button type="button" class="aa-button aa-button--secondary" data-aa-anchor-type-open>+ Add Task Type</button>',
    '<div data-aa-anchor-type-entry hidden style="margin-top:10px">',
    '<input type="text" data-aa-anchor-type-name placeholder="New Task Type" aria-label="New Task Type" maxlength="90">',
    '<button type="button" class="aa-button aa-button--primary" data-aa-anchor-type-save>Save Type</button>',
    '<button type="button" class="aa-button aa-button--secondary" data-aa-anchor-type-cancel>Cancel</button>',
    '</div></div>'
  ].join('');

  for(const key of ['renderTaskAnchorEditor','renderSharedTaskAnchorEditor']) {
    const old = proto[key];
    if (typeof old !== 'function') continue;
    proto[key] = function(...args) {
      return old.apply(this,args).replace(
        /(<span>Task Type<\/span>\s*<select\b[\s\S]*?<\/select>\s*<\/label>)/,
        '$1'+newTypeHtml
      );
    };
  }

  const oldBind = proto.bindTaskAnchorActions;
  if (typeof oldBind === 'function') {
    proto.bindTaskAnchorActions = function() {
      oldBind.call(this);
      this.root.addEventListener('click', async event => {
        const control = event.target.closest?.('[data-aa-anchor-type-open], [data-aa-anchor-type-save], [data-aa-anchor-type-cancel]');
        if(!control) return;
        event.preventDefault();
        const wrapper = control.closest('.aa-anchor-type-create');
        const entry = wrapper?.querySelector('[data-aa-anchor-type-entry]');
        const field = wrapper?.querySelector('[data-aa-anchor-type-name]');
        if(!entry || !field) return;
        if(control.hasAttribute('data-aa-anchor-type-open')) {
          entry.hidden=false; field.focus(); return;
        }
        if(control.hasAttribute('data-aa-anchor-type-cancel')) {
          entry.hidden=true; field.value=''; return;
        }
        const name = field.value.trim();
        if(!name) { this.showStatusMessage('Enter the new Task Type name.','error'); field.focus(); return; }
        control.disabled=true;
        control.textContent='Saving...';
        try {
          await api.addTaskType({name});
          this.taskTypes = await api.getTaskTypes();
          const form = wrapper.closest('[data-aa-task-anchor-form], [data-aa-shared-task-anchor-form]');
          const dropdown = form?.querySelector('[data-aa-task-anchor-field="task_type"], [data-aa-shared-task-anchor-field="task_type"]');
          if(dropdown) {
            let option = [...dropdown.options].find(o=>o.value.toLowerCase()===name.toLowerCase());
            if(!option) {
              option=document.createElement('option');
              option.value=name; option.textContent=name;
              dropdown.add(option);
            }
            dropdown.value=option.value;
            dropdown.dispatchEvent(new Event('change',{bubbles:true}));
          }
          entry.hidden=true; field.value='';
          this.showStatusMessage('Task Type saved. Finish your Task Anchor and click Save.','success');
        } catch(error) {
          console.warn('Task Type was not created:',error);
          this.showStatusMessage(error?.message || 'Unable to add Task Type.','error');
        } finally {
          control.disabled=false; control.textContent='Save Type';
        }
      });
    };
  }

  const oldStatus = proto.showStatusMessage;
  if (typeof oldStatus === 'function') {
    proto.showStatusMessage = function(message,tone) {
      if (typeof message === 'string' &&
        (/^Unable to (save|update) (Shared )?Task Anchor\.$/).test(message) &&
        lastSaveError) {
        message += ' '+lastSaveError;
        lastSaveError='';
      }
      return oldStatus.call(this,message,tone);
    };
  }

  const Builder = window.AATemplateBuilder;
  if(Builder?.prototype && !Builder.prototype.__aaDraftNoticeRepair) {
    const original = Builder.prototype.render;
    if(typeof original === 'function') {
      Builder.prototype.render = function(...args) {
        // A saved client draft is normal. The status indicator already shows it.
        if(this.builderMessage==='Draft restored.') this.builderMessage='';
        return original.apply(this,args);
      };
    }
    Builder.prototype.__aaDraftNoticeRepair=true;
  }
  proto.__aaTaskAnchorRepair=true;
})();